<div class="right-side p-2">
  <h2 class="mt-4">Response for Expression of Interest (EOI) For Participation in Exhibitions</h2>
  <div class="section">
    <form [formGroup]="frmEOIList">
      <div class="row">
        <div class="text-end">
          <button (click)="LoadEOIRecordExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
          <button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>
        </div>
      </div>



      <div class="row">
        <div class="col-lg-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" placeholder="Enter from date">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toPicker" formControlName="toDate" placeholder="Enter to date">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>
        </div>
          <div class="col-lg-2">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Registration Type</mat-label>

      <mat-select formControlName="registrationType">
        <mat-option value="">All</mat-option>
        <mat-option value="MSME">MSME</mat-option>
        <mat-option value="Artisan">Artisan</mat-option>
      </mat-select>

    </mat-form-field>
  </div>

        <div class="col-lg-6 search-container">
          <mat-form-field class="search-input w-75" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput formControlName="searchControl" />
          </mat-form-field>
          <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(frmEOIList.get('searchControl')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>
        </div>
      </div>

  
   
<div class="table-responsive">

  <table mat-table
         [dataSource]="dataSource"
         matSort
         class="table table-striped table-bordered table-hover"
         matTableResponsive
         matSortActive="CreatedDate"
         matSortDirection="desc"
         matSortDisableClear>

    <!-- Sr No -->
    <ng-container matColumnDef="RowNum">
      <th mat-header-cell *matHeaderCellDef>
        Sr.No
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.RowNum }}
      </td>
    </ng-container>




    <!-- Application Id -->
    <ng-container matColumnDef="ApplicationId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        EOI Exhibition Response Number
      </th>

      <td mat-cell *matCellDef="let el">
        <a class="text-primary no-underline"
           style="cursor: pointer;"
           (click)="action(el.ApplicationId)">
          {{ el.ApplicationId }}
        </a>
      </td>
    </ng-container>

       <!-- Registration Type -->
    <ng-container matColumnDef="registrationType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Registration Type
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.registrationType }}
      </td>
    </ng-container>

    <!-- Enterprise Name -->
    <!-- <ng-container matColumnDef="EoiExhibitionName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Enterprise Name
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.EoiExhibitionName }}
      </td>
    </ng-container> -->

    <!-- Udyam Number -->
    <ng-container matColumnDef="UdyamNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Udyam Number
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.udyamNumber }}
      </td>
    </ng-container>

<!-- MSME Name -->
<ng-container matColumnDef="msmEName">
  <th mat-header-cell *matHeaderCellDef >
    MSME Name
  </th>

  <td mat-cell *matCellDef="let el">
    {{ el.MsmEName }}
  </td>
</ng-container>

    <!-- Artisan Number -->
<ng-container matColumnDef="artisanNumber">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>
    Artisan / Pehchan Card Number
  </th>

  <td mat-cell *matCellDef="let el">
    {{ el.artisanNumber || '-' }}
  </td>
</ng-container>

<ng-container matColumnDef="artisanName">
  <th mat-header-cell *matHeaderCellDef >
    Artisan Name
  </th>

  <td mat-cell *matCellDef="let el">
    {{ el.artisanName }}
  </td>
</ng-container>


    <!-- Year Of Establishment -->
    <ng-container matColumnDef="YearOfEstablishment">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Year Of Establishment
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.YearOfEstablishment }}
      </td>
    </ng-container>

    <!-- Submission Date -->
    <ng-container matColumnDef="CreatedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Submission Date
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.CreatedDate | date:'dd-MM-yyyy' }}
      </td>
    </ng-container>

    <!-- Industry Sector -->
    <ng-container matColumnDef="IndustrySector">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Industry Sector
      </th>

      <td mat-cell *matCellDef="let el">

        {{
          el.registrationType === 'MSME'
            ? (
                el.industrySectorSelect === 'Other'
                  ? el.industrySectorOther
                  : el.industrySectorSelect
              )
            : el.IndustrySector
        }}

      </td>
    </ng-container>

    <!-- Gender -->
    <ng-container matColumnDef="Gender">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Gender
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.Gender }}
      </td>
    </ng-container>

    <!-- District -->
    <ng-container matColumnDef="DistrictName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        District
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.DistrictName }}
      </td>
    </ng-container>

    <!-- Organization Type -->
    <ng-container matColumnDef="OrganizationTypeName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Organization Type
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.OrganizationTypeName }}
      </td>
    </ng-container>

    <!-- Social Category -->
    <ng-container matColumnDef="SocialCategoryName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Social Category
      </th>

      <td mat-cell *matCellDef="let el">
        {{ el.SocialCategoryName }}
      </td>
    </ng-container>

    <!-- Application Download -->
    <ng-container matColumnDef="ApplicationDownload">
      <th mat-header-cell *matHeaderCellDef>
        Application Download
      </th>

      <td mat-cell *matCellDef="let el">
        <button mat-raised-button
                color="primary"
                *ngIf="el.DownloadEOIExhibitionFilePath"
                (click)="downloadEoiExhibitionFile(el.DownloadEOIExhibitionFilePath, el.ApplicationId)">

          <i class="bi bi-download"></i>
          Download

        </button>
      </td>
    </ng-container>

    <!-- Documents Download -->
    <ng-container matColumnDef="DocumentsDownload">
      <th mat-header-cell *matHeaderCellDef>
        Documents
      </th>

      <td mat-cell *matCellDef="let el">
        <button mat-raised-button
                color="primary"
                *ngIf="el.ZipFilePath"
                (click)="downloadEoiExihibitionDocuments(el.ZipFilePath, el.ApplicationId)">

          <i class="bi bi-download"></i>
          Download

        </button>
      </td>
    </ng-container>

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <!-- Data Row -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- No Data -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center" colspan="15">
        No data matching the filter
      </td>
    </tr>

  </table>

</div>
   
      <mat-paginator #paginator
                     class="demo-paginator"
                     (page)="onPageChange($event)"
                     [length]="length"
                     [pageSize]="pageSize"
                     [showFirstLastButtons]="showFirstLastButtons"
                     [pageSizeOptions]="pageSizeOptions"
                     [hidePageSize]="hidePageSize"
                     [pageIndex]="pageIndex"
                     aria-label="Select page">
      </mat-paginator>
    </form>
  </div>
</div>


